// Avatar Coach Bruno — versione "cute chibi" del tennista guida.
// Big head, big eyes, rosy cheeks, smile, racket prominentemente in mano.
// Palette: pelle calda, divisa bianca con dettagli verdi (tennis classico),
// pallina verde fluo, racchetta scura con corde.
import React from "react";

export const TennisCoachAvatar = ({ size = 40, animate = false, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className} ${animate ? "tennis-coach-bounce" : ""}`}
      aria-label="Coach Bruno"
      role="img"
    >
      <defs>
        <radialGradient id="bgGrad" cx="0.5" cy="0.55" r="0.7">
          <stop offset="0%" stopColor="#ecfccb" />
          <stop offset="100%" stopColor="#d9f99d" />
        </radialGradient>
        <linearGradient id="skinGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#fde0c2" />
          <stop offset="100%" stopColor="#f5c79b" />
        </linearGradient>
        <linearGradient id="poloGrad" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#e2e8f0" />
        </linearGradient>
      </defs>

      {/* Sfondo cerchio gradient verde chiaro */}
      <circle cx="32" cy="32" r="32" fill="url(#bgGrad)" />

      {/* Corpo / polo */}
      <ellipse cx="32" cy="55" rx="20" ry="14" fill="url(#poloGrad)" />
      {/* Colletto verde */}
      <path d="M24 44 L32 50 L40 44 L40 47 L32 53 L24 47 Z" fill="#15803d" />
      {/* Numero polo */}
      <text x="32" y="61" textAnchor="middle" fontFamily="Arial Black, sans-serif" fontSize="6" fontWeight="900" fill="#15803d">1</text>

      {/* Collo */}
      <rect x="29" y="38" width="6" height="6" fill="url(#skinGrad)" />

      {/* Testa grande tondo (chibi) */}
      <circle cx="32" cy="28" r="14" fill="url(#skinGrad)" />
      {/* Orecchie */}
      <circle cx="18.5" cy="29" r="2.5" fill="url(#skinGrad)" />
      <circle cx="45.5" cy="29" r="2.5" fill="url(#skinGrad)" />
      <circle cx="18.5" cy="29.5" r="1" fill="#e09775" />
      <circle cx="45.5" cy="29.5" r="1" fill="#e09775" />

      {/* Capelli (ciuffo morbido) */}
      <path
        d="M19 24 Q19 14 32 13 Q45 14 45 24 Q44 20 40 19 Q37 22 32 21 Q27 22 24 19 Q20 20 19 24 Z"
        fill="#4b3422"
      />
      {/* Ciuffo frontale */}
      <path d="M27 19 Q30 16 33 18 Q34 20 30 22 Q27 21 27 19 Z" fill="#3a2618" />

      {/* Fascia verde fluo sulla fronte */}
      <rect x="18.5" y="22" width="27" height="3" rx="1" fill="#65a30d" />
      <rect x="18.5" y="22" width="27" height="0.8" fill="#a3e635" />

      {/* Occhi grandi (chibi) */}
      <ellipse cx="27" cy="31" rx="2.5" ry="3.2" fill="#ffffff" />
      <ellipse cx="37" cy="31" rx="2.5" ry="3.2" fill="#ffffff" />
      <circle cx="27" cy="31.5" r="2" fill="#1e293b" />
      <circle cx="37" cy="31.5" r="2" fill="#1e293b" />
      {/* Glow negli occhi */}
      <circle cx="27.8" cy="30.5" r="0.7" fill="#ffffff" />
      <circle cx="37.8" cy="30.5" r="0.7" fill="#ffffff" />
      <circle cx="26.3" cy="32.3" r="0.35" fill="#ffffff" opacity="0.8" />
      <circle cx="36.3" cy="32.3" r="0.35" fill="#ffffff" opacity="0.8" />

      {/* Sopracciglia (sottili, arcuate) */}
      <path d="M24.5 27.5 Q27 26.5 29.5 27.5" stroke="#3a2618" strokeWidth="1.4" fill="none" strokeLinecap="round" />
      <path d="M34.5 27.5 Q37 26.5 39.5 27.5" stroke="#3a2618" strokeWidth="1.4" fill="none" strokeLinecap="round" />

      {/* Guance rosa (rosy cheeks) */}
      <ellipse cx="22.5" cy="35.5" rx="2.3" ry="1.5" fill="#fca5a5" opacity="0.65" />
      <ellipse cx="41.5" cy="35.5" rx="2.3" ry="1.5" fill="#fca5a5" opacity="0.65" />

      {/* Sorriso ampio */}
      <path
        d="M27 37 Q32 41 37 37"
        stroke="#7c2d12"
        strokeWidth="1.6"
        fill="none"
        strokeLinecap="round"
      />
      {/* Bocca aperta - lingua leggera */}
      <path
        d="M30 38.5 Q32 40 34 38.5 Q32 39.8 30 38.5"
        fill="#dc2626"
        opacity="0.55"
      />

      {/* Braccio destro che tiene la racchetta */}
      <g transform="translate(48 47) rotate(15)">
        {/* Manico racchetta */}
        <rect x="-1.2" y="-12" width="2.4" height="14" rx="0.8" fill="#1e293b" />
        <rect x="-1.6" y="-1.5" width="3.2" height="2.5" fill="#dc2626" />
        {/* Testa racchetta */}
        <ellipse cx="0" cy="-18" rx="7" ry="8" fill="none" stroke="#1e293b" strokeWidth="1.8" />
        <ellipse cx="0" cy="-18" rx="6" ry="7" fill="#fef3c7" opacity="0.4" />
        {/* Corde verticali */}
        <line x1="-4" y1="-23" x2="-4" y2="-13" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="-2" y1="-24" x2="-2" y2="-12" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="0" y1="-25" x2="0" y2="-11" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="2" y1="-24" x2="2" y2="-12" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="4" y1="-23" x2="4" y2="-13" stroke="#94a3b8" strokeWidth="0.45" />
        {/* Corde orizzontali */}
        <line x1="-5" y1="-21" x2="5" y2="-21" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="-6" y1="-19" x2="6" y2="-19" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="-6" y1="-17" x2="6" y2="-17" stroke="#94a3b8" strokeWidth="0.45" />
        <line x1="-5" y1="-15" x2="5" y2="-15" stroke="#94a3b8" strokeWidth="0.45" />
      </g>

      {/* Pallina da tennis fluo che vola */}
      <g transform="translate(13 16)">
        <circle cx="0" cy="0" r="4.2" fill="#c8e414" />
        <circle cx="-1" cy="-1" r="1.2" fill="#e3f578" opacity="0.7" />
        <path d="M-3.5 -1.2 Q0 -3.5 3.5 -1.2" stroke="#ffffff" strokeWidth="0.7" fill="none" />
        <path d="M-3.5 1.2 Q0 3.5 3.5 1.2" stroke="#ffffff" strokeWidth="0.7" fill="none" />
        {/* Linee di movimento */}
        <line x1="-7" y1="-3" x2="-9" y2="-5" stroke="#94a3b8" strokeWidth="0.6" strokeLinecap="round" opacity="0.6" />
        <line x1="-7" y1="0" x2="-10" y2="0" stroke="#94a3b8" strokeWidth="0.6" strokeLinecap="round" opacity="0.6" />
        <line x1="-7" y1="3" x2="-9" y2="5" stroke="#94a3b8" strokeWidth="0.6" strokeLinecap="round" opacity="0.6" />
      </g>

      <style>
        {`
          @keyframes tennisCoachBounce {
            0%, 100% { transform: translateY(0); }
            50% { transform: translateY(-2.5px); }
          }
          .tennis-coach-bounce {
            animation: tennisCoachBounce 1.6s ease-in-out infinite;
          }
        `}
      </style>
    </svg>
  );
};

export default TennisCoachAvatar;
